import React from "react";
import { useTranslation } from "react-i18next";
import PageShell from "../components/PageShell";
import ContactSection from "../sections/Contact";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <PageShell title={t("contact.pageTitle")} mainClass="page">
      <ContactSection />
    </PageShell>
  );
};

export default Contact;
